import { EnterPartnerComponent } from './../public/enter-partner/enter-partner.component';
import { RegisterPartnerComponent } from './../public/register/register-partner.component';
import { NgModule } from '@angular/core';
import { CoreModule } from 'src/app/core/core.module';
import { RecaptchaFormsModule, RecaptchaModule } from "ng-recaptcha";
import { LoginGoogleComponent } from './login-google/login-google.component';


@NgModule({
    imports: [
        CoreModule,
        RecaptchaModule,
        RecaptchaFormsModule
    ],
    declarations: [
        EnterPartnerComponent,
        RegisterPartnerComponent,
        LoginGoogleComponent
    ],
    providers: [
    ],
    exports: [
    ]
})
export class PublicModule { }
